<template>
  <div class="zbzx-box">
    <div class="zbzx-box-container">
      <div class="zbzx-top">
        <div class="zbzx-top-item" @click="handleShenqingZhibo(true)">
          <span class="zbzx-top-item-text">{{$t('all.shenqingzhibo')}}</span>
        </div>
        <div class="zbzx-top-item" @click="handleShenqingJilu">
          <span class="zbzx-top-item-text">{{$t('all.shenqingjilu')}}</span>
        </div>
        <div class="zbzx-top-item" @click="handleHuifangJilu">
          <span class="zbzx-top-item-text">{{$t('all.huifangjilu')}}</span>
        </div>
      </div>
      <div class="zbzx-title">
		<div class="zbzx-title-box">
			<span class="zbzx-title-span">{{$t('all.zhibojilu')}}</span>
			<span class="zbzx-title-span1"></span>
		</div>
	</div>
      <div class="zbzx-list">
        <zbList v-for="(item,index) in list" :key="index" :data="item" :type="1" @delete="handleListDelete"></zbList>
      </div>
      <div class="zbzx-kong" v-if="!isLoading && loaded && list.length === 0">
      	<kong></kong>
      </div>
    </div>
	
	<!-- 申请直播弹框 -->
	<div class="sq-overlay" v-if="showSqModal" @click="showSqModal = false"></div>
	<div class="sq-modal-wrap" v-if="showSqModal" @click.stop>
		<div class="sq-modal">
			<div class="sq-modal-title">{{$t('all.shenqingzhibo')}}</div>
			<div class="sq-modal-row">
				<div class="sq-modal-field" @click="handleShowCalendar">
					<span class="sq-modal-field-label">{{$t('all.zhiboriqi')}}</span>
					<span class="sq-modal-field-value">{{sqForm.liveDate || $t('all.qingxuanze')}}</span>
					<img class="sq-modal-field-icon" src="../../../assets/image/rili_28@2x.png" alt="" />
				</div>
				<div class="sq-modal-field" @click="handleShowCalendar">
					<span class="sq-modal-field-label">{{$t('all.shijianshiduan')}}</span>
					<span class="sq-modal-field-value">{{sqForm.timeSlot || $t('all.qingxuanze')}}</span>
					<img class="sq-modal-field-icon" src="../../../assets/image/rili_28@2x.png" alt="" />
				</div>
			</div>
			<div class="sq-modal-row">
				<div :class="sqForm.liveType === 1 ? 'sq-modal-type-active' : 'sq-modal-type'" @click="sqForm.liveType = 1">{{$t('all.shoujizhibo')}}</div>
				<div :class="sqForm.liveType === 2 ? 'sq-modal-type-active' : 'sq-modal-type'" @click="sqForm.liveType = 2">OBS{{$t('all.zhibo')}}</div>
			</div>
			<div class="sq-modal-item">
				<span class="sq-modal-item-label">{{$t('all.zhibodaihuo')}}</span>
				<div class="sq-modal-item-tag" @click="sqForm.isDaihuo = !sqForm.isDaihuo">{{sqForm.isDaihuo ? $t('all.kaiqi') : $t('all.guanbi')}}</div>
			</div>
			<div class="sq-modal-item" v-if="sqForm.isDaihuo">
				<span class="sq-modal-item-label">UNImall【{{$t('all.zhanghaoid')}}】</span>
				<input class="sq-modal-item-input" v-model="sqForm.accountId" :placeholder="$t('all.qingtianxie')" />
			</div>
			<div class="sq-modal-item sq-modal-item-beizhu">
				<span class="sq-modal-item-label">{{$t('all.beizhu')}}</span>
				<input class="sq-modal-item-input" v-model="sqForm.remark" :placeholder="$t('all.huodongzhuti')" />
			</div>
			<div class="sq-modal-item">
				<span class="sq-modal-item-label">{{$t('all.shenqinghouliucheng')}}</span>
				<div class="sq-modal-item-tag sq-modal-item-tag-pending">{{$t('all.daishenhe')}}</div>
			</div>
			<div class="sq-modal-item-desc">{{$t('all.shenqinghouliuchengdesc')}}</div>
			<div class="sq-modal-btn" @click="handleSubmitSq">{{$t('all.tijiaoshenqing')}}</div>
		</div>
		<!-- 右侧日历面板 -->
		<div class="sq-calendar" v-if="showCalendar">
			<div class="sq-calendar-header">
				<img class="sq-calendar-arrow" src="../../../assets/image/riqi_qian@2x.png" alt="" @click="changeMonth(-1)"/>
				<span class="sq-calendar-month">{{calendarMonthText}}</span>
				<img class="sq-calendar-arrow" src="../../../assets/image/riqi_hou@2x.png" alt="" @click="changeMonth(1)"/>
				<span class="sq-calendar-tip">{{$t('all.tongshiduanbukezhongfu')}}</span>
			</div>
			<div class="sq-calendar-weekdays">
				<span v-for="d in weekDays" :key="d">{{d}}</span>
			</div>
			<div class="sq-calendar-days">
				<span 
					v-for="(day, idx) in calendarDays" 
					:key="idx" 
					:class="getDayClass(day)"
					@click="selectDay(day)"
				>{{day.num || ''}}</span>
			</div>
			<div class="sq-calendar-slots-title">{{$t('all.keshenqingshiduan')}}</div>
			<div class="sq-calendar-slots">
				<div 
					v-for="(slot, idx) in timeSlots" 
					:key="idx"
					:class="selectedSlot === idx ? 'sq-calendar-slot-active' : 'sq-calendar-slot'"
					@click="selectedSlot = idx"
				>{{slot}}</div>
			</div>
			<div class="sq-calendar-confirm" @click="confirmDateTime">{{$t('all.querenShiduan')}}</div>
		</div>
	</div>
  </div>
</template>

<script>
import { getUserLiveRecordList } from "@/api/zhibo";
import { submitLiveApply, getUserLiveApplyRecordList, getLiveApplyTimeList } from "@/api/zhiboshenqing";
import kong from "../../../components/kong/kong.vue";
import zbList from "../../../components/zbList/zbList.vue";
export default {
  components: { kong,zbList },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.showSqModal = to.query.showSqModal === 'true';
      if (vm.showSqModal) {
        vm.handleShenqingZhibo(true);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const shouldShow = to.query.showSqModal === 'true';
    this.showSqModal = shouldShow;
    if (shouldShow) {
      this.handleShenqingZhibo(true);
    }
    next();
  },
  data() {
    return {
      list: [],
      queryParams: {
        page: 1,
        size: 20,
        viewUserId: ''
      },
      showSqModal: false,
      showCalendar: false,
      sqForm: {
        liveDate: '',
        timeSlot: '',
        timeRange: null,
        liveType: 1,
        isDaihuo: false,
        remark: '',
        accountId: ''
      },
      calendarYear: new Date().getFullYear(),
      calendarMonth: new Date().getMonth() + 1,
      selectedDay: new Date().getDate(),
      selectedSlot: -1,
      timeSlots: [],
      weekDays: [],
      isLoading: false,
      loaded: false
    };
  },
  computed: {
    calendarMonthText() {
      return this.calendarYear + this.$t('all.nian') + this.calendarMonth + this.$t('all.yue');
    },
    calendarDays() {
      const year = this.calendarYear;
      const month = this.calendarMonth;
      const firstDay = new Date(year, month - 1, 1).getDay(); // 0=Sun
      const daysInMonth = new Date(year, month, 0).getDate();
      const today = new Date();
      const todayDate = today.getDate();
      const todayMonth = today.getMonth() + 1;
      const todayYear = today.getFullYear();
      // Monday=0 offset
      const offset = firstDay === 0 ? 6 : firstDay - 1;
      const days = [];
      for (let i = 0; i < offset; i++) {
        days.push({ num: null });
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const isPast = (year < todayYear) || (year === todayYear && month < todayMonth) || (year === todayYear && month === todayMonth && d < todayDate);
        days.push({ num: d, isPast, isSelected: this.selectedDay === d });
      }
      return days;
    }
  },
  mounted() {
    this.queryParams.viewUserId = this.$store.state.userId;
    this.weekDays = [
      this.$t('all.zhou1'), this.$t('all.zhou2'), this.$t('all.zhou3'),
      this.$t('all.zhou4'), this.$t('all.zhou5'), this.$t('all.zhou6'), this.$t('all.zhou7')
    ];
    this.getList();
  },
  methods: {
    async getList() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const response = await getUserLiveRecordList(this.queryParams);
        this.list = response.rows || [];
      } catch (error) {
        console.error("获取直播记录失败:", error);
        this.list = [];
      } finally {
        this.isLoading = false;
        this.loaded = true;
      }
    },
    async handleShenqingZhibo(showModal = true) {
      if (showModal) {
        this.showSqModal = true;
      }
      this.showCalendar = false;
      this.sqForm.liveDate = '';
      this.sqForm.timeSlot = '';
      const today = new Date();
      this.calendarYear = today.getFullYear();
      this.calendarMonth = today.getMonth() + 1;
      this.selectedDay = today.getDate();
      this.selectedSlot = -1;
      await this.fetchAvailableSlots();
    },
    async handleShowCalendar() {
      this.showCalendar = true;
      const today = new Date();
      // 如果有 liveDate，解析并设置日历
      if (this.sqForm.liveDate) {
        const parts = this.sqForm.liveDate.split('/');
        if (parts.length === 3) {
          this.calendarYear = parseInt(parts[0]);
          this.calendarMonth = parseInt(parts[1]);
          this.selectedDay = parseInt(parts[2]);
        }
      } else {
        // 如果没有，使用当天日期并默认选中
        this.calendarYear = today.getFullYear();
        this.calendarMonth = today.getMonth() + 1;
        this.selectedDay = today.getDate();
      }
      // 获取可用时间段
      await this.fetchAvailableSlots();
    },
    async fetchAvailableSlots() {
      try {
        const dateStr = `${this.calendarYear}-${String(this.calendarMonth).padStart(2, '0')}-${String(this.selectedDay || new Date().getDate()).padStart(2, '0')}`;
        const res = await getLiveApplyTimeList({ liveDate: dateStr });
        const data = res.data || res;
        if (Array.isArray(data)) {
          this.timeSlots = data;
        }
      } catch (error) {
        console.error("获取可用时段失败:", error);
      }
    },
    handleShenqingJilu() {
      this.$router.push('/shenqingjilu');
    },
    handleHuifangJilu() {
      this.$router.push('/huifang');
    },
    handlePlayVideo(item) {
      this.$router.push({ 
        path: '/huifang', 
        query: { 
          url: item.replayUrl, 
          name: item.name, 
          period: item.period 
        } 
      });
    },
    handleListDelete() {
      this.queryParams.page = 1;
      this.getList();
    },
    async handleSubmitSq() {
      const vo = {
        isGoods: this.sqForm.isDaihuo ? 1 : 0,
        liveDate: this.sqForm.liveDate.replace(/\//g, '-'),
        liveTime: this.sqForm.timeSlot,
        liveType: this.sqForm.liveType,
        businessAccount: this.sqForm.accountId || '',
        submitMsg: this.sqForm.remark || ''
      };
      const res = await submitLiveApply(vo);
      this.$message.success(res.msg || this.$t('all.tijiaochenggong'));
      this.showSqModal = false;
      this.sqForm = {
        liveDate: '',
        timeSlot: '',
        timeRange: null,
        liveType: 1,
        isDaihuo: true,
        remark: '',
        accountId: ''
      };
      this.$router.push({
        path: '/tijiaoshenqing',
        query: {
          liveDate: vo.liveDate,
          timeSlot: vo.liveTime
        }
      });
    },
    changeMonth(offset) {
      this.calendarMonth += offset;
      if (this.calendarMonth > 12) {
        this.calendarMonth = 1;
        this.calendarYear++;
      } else if (this.calendarMonth < 1) {
        this.calendarMonth = 12;
        this.calendarYear--;
      }
      this.fetchAvailableSlots();
    },
    getDayClass(day) {
      if (!day.num) return 'sq-calendar-day-empty';
      if (day.isSelected) return 'sq-calendar-day-selected';
      if (day.isPast) return 'sq-calendar-day-past';
      return 'sq-calendar-day';
    },
    selectDay(day) {
      if (!day.num || day.isPast) return;
      this.selectedDay = day.num;
      this.selectedSlot = -1;
      this.fetchAvailableSlots();
    },
    confirmDateTime() {
      if (!this.selectedDay) {
        this.$message.warning(this.$t('all.qingxuanzeriqi'));
        return;
      }
      if (this.selectedSlot < 0) {
        this.$message.warning(this.$t('all.qingxuanzeshijian'));
        return;
      }
      const month = String(this.calendarMonth).padStart(2, '0');
      const day = String(this.selectedDay).padStart(2, '0');
      this.sqForm.liveDate = `${this.calendarYear}/${month}/${day}`;
      this.sqForm.timeSlot = this.timeSlots[this.selectedSlot];
      this.showCalendar = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "./zhibozhongxin.css";
</style>



// WEBPACK FOOTER //
// zhibozhongxin.vue?279e8841